import { Facet } from "@linkfluence/models/facet";

const ALLOWED_METRICS = [
  Facet.Tones,
  Facet.Keyphrases,
  Facet.Hashtags,
  Facet.GeoLocations,
  Facet.Occupations,
  Facet.Genders,
  Facet.Emotions,
  Facet.Affects,
  Facet.ContentClassification,
] as const;
type AichaFacet = typeof ALLOWED_METRICS[number];

export const isAichaFacet = (facet: string): facet is AichaFacet =>
  ALLOWED_METRICS.includes(facet as AichaFacet);

export type FocusMetrics = {
  name: AichaFacet;
  value: string;
};

export const BASE_SUGGESTIONS = [
  "I want to analyze negative content",
  "I want to compare brands performance",
  "I want to see the most popular contents on social media",
]; // todo make it a function that accepts a locale

export const CONFIRM_SUGGESTIONS = [
  { text: "It's perfect! Thanks and goodbye!", confirm: true },
];
export type ThreadMessage = {
  from: "user" | "bot" | "loader";
  message: string;
};
